import { FiRollupContentModule } from '@fi-shared/rollup/rollup-content.module';
import { FiTaskV2DescriptionAccordionComponent } from './fi-task-v2-description-accordion/fi-task-v2-description-accordion.component';
import { FiTaskV2AttachmentsShortComponent } from './fi-task-v2-attachments-short/fi-task-v2-attachments-short.component';
import { FiTaskV2StatusSelectComponent } from './fi-task-v2-status-select/fi-task-v2-status-select.component';
import { FiTaskV2DeadlineStatusComponent } from './fi-task-v2-deadline-status/fi-task-v2-deadline-status.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTaskV2PriorityBadgeComponent } from './fi-task-v2-priority-badge/fi-task-v2-priority-badge.component';
import { MatCardModule } from '@angular/material/card';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatButtonModule } from '@angular/material/button';
import { FiTaskV2CommentsComponent } from './task-v2-comments/task-v2-comments.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FiCommentsListModule } from '@fi-shared/fi-comments/fi-comments-list/fi-comments-list.module';
import { FiTaskV2ReportStatusBadgeComponent } from '@fi-app/task-v2/components/fi-task-v2-report-status-badge/fi-task-v2-report-status-badge.component';
import { TaskV2ArchivedBannerComponent } from './task-v2-archived-banner/task-v2-archived-banner.component';
import { FiInfoBannerModule } from '@fi-shared/fi-info-banner/fi-info-banner.module';
import { MatDividerModule } from '@angular/material/divider';
import { FiTaskV2IntroComponent } from './fi-task-v2-intro/fi-task-v2-intro.component';
import { FiTaskV2AutomatedDescriptionComponent } from './fi-task-v2-automated-description/fi-task-v2-automated-description.component';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiTaskV2CurrentLocationInfoComponent } from '@fi-app/task-v2/components/fi-task-v2-current-location-info/fi-task-v2-current-location-info.component';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiProgressBadgeModule } from '@fi-app/shared/fi-progress-badge/fi-progress-badge.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        FiAppTextSharedModule,
        MatIconModule,
        MatSelectModule,
        FormsModule,
        FiAttachmentsModule,
        FiRollupContentModule,
        MatButtonModule,
        MatExpansionModule,
        FiCommentsListModule,
        FiInfoBannerModule,
        MatDividerModule,
        FiBindHtmlCompileModule,
        FiTooltipModule,
        FiProgressBadgeModule,
    ],
    declarations: [
        FiTaskV2PriorityBadgeComponent,
        FiTaskV2DeadlineStatusComponent,
        FiTaskV2StatusSelectComponent,
        FiTaskV2AttachmentsShortComponent,
        FiTaskV2DescriptionAccordionComponent,
        FiTaskV2ReportStatusBadgeComponent,
        FiTaskV2CommentsComponent,
        TaskV2ArchivedBannerComponent,
        FiTaskV2IntroComponent,
        FiTaskV2AutomatedDescriptionComponent,
        FiTaskV2CurrentLocationInfoComponent,
    ],
    exports: [
        FiTaskV2PriorityBadgeComponent,
        FiTaskV2DeadlineStatusComponent,
        FiTaskV2StatusSelectComponent,
        FiTaskV2AttachmentsShortComponent,
        FiTaskV2DescriptionAccordionComponent,
        FiTaskV2ReportStatusBadgeComponent,
        FiTaskV2CommentsComponent,
        TaskV2ArchivedBannerComponent,
        FiTaskV2IntroComponent,
        FiTaskV2AutomatedDescriptionComponent,
        FiTaskV2CurrentLocationInfoComponent,
    ],
})
export class FiTaskV2SharedComponentsModule {}
